var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',_vm._b({ref:"datepicker",attrs:{"locale":_vm.localeFixed,"value":_vm.date,"color":"gray"},on:{"input":_vm.handleInput}},'DatePicker',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }